import IAsset from "../../../models/IAsset";

interface PdfAssetPreviewProps {
  asset: IAsset;
}

export default function PdfAssetPreview({ asset }: Readonly<PdfAssetPreviewProps>) {
  if (!asset) return null;
  return (
    <div>
      <iframe src={`/api/Asset/${asset.blobPath}`} title={asset.name} width="100%" height="400px" />
      <div>{asset.name}</div>
    </div>
  );
}
